import { Component, OnChanges, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { DadosPessoaisService } from './dados-pessoais.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { AreaService } from 'app/service/cliente/area.service';
import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from 'app/components/dialog/dialog-confirm/dialog-confirm.component';

@Component({
  selector: 'app-dados-pessoais',
  templateUrl: './dados-pessoais.component.html',
  styleUrls: ['./dados-pessoais.component.scss']
})
export class DadosPessoaisComponent implements OnInit, OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dadoForm: FormGroup;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  submit = false;
  tiposDados = [];
  areas = [];
  tipos = [];
  loading = true;
  loading1TipoDado = false;
  loading1Cliente = false;
  public clientes: ClienteModel[];
  public clienteId;
  public areaId;
  maskCpf = [
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
  ];
  displayedColumns = ['titular', 'cpf', 'empresa', 'area', 'tipo',
  'finalidade', 'tipoDado', 'valor', 'acoes'];
  dataSource = new MatTableDataSource<any[]>([]);

  constructor(
    private dadosPessoaisService: DadosPessoaisService,
    private fb: FormBuilder,
    private areaService: AreaService,
    private service: ConfigurarPastaServiceService,
    private clienteService: ClienteService,
    iconRegistry: MatIconRegistry,
    private dialog: MatDialog,
    sanitizer: DomSanitizer,
    private _snackBar: MatSnackBar) {
      iconRegistry.addSvgIcon('question', sanitizer.bypassSecurityTrustResourceUrl('../../../../assets/images/question-circle.svg'));
     }

  ngOnInit() {
    // Criar o formulário
    this.dadoForm = this.fb.group({
      id: [''],
      nomeTitular: ['', Validators.required],
      cpfTitular: ['', Validators.required],
      finalidade: ['', Validators.required],
      cliente: ['', Validators.required],
      area: ['', Validators.required],
      nodeDicionario: ['', Validators.required],
      tipoDado: ['', Validators.required],
      valorDado: ['', Validators.required],
    });

    this.buscarTiposDados();
    this.buscarClientesUsuario();
    this.buscarTodosOsDadosPessoais();
  }

  ngOnChanges() {
  }

  salvarDadoPessoal() {
    if (this.dadoForm.valid) {
      this.dadosPessoaisService.saveDadoPessoal(this.dadoForm.value).subscribe(data => {
        console.log(data);
        this.openSnackBarSuccess('Dado Pessoal adicionado com sucesso !');
      }, err => {
        console.error(err);
      }, () => {
        console.log('complete');
      });
    } else {
      this.openSnackBarError('Formulário com erros !');
    }
  }

  onSubmit() {
    this.submit = true;
    this.salvarDadoPessoal();
  }

  reset() {
    this.submit = false;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  deleteDadoPessoal(id: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja apagar este dado ?', from: 'dados-pessoais.component.ts'}
    });

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.apagarDado(id);
      }
    });
  }

  apagarDado(id) {
    this.dadosPessoaisService.apagarDadoPessoal(id).subscribe(data => {
      this.openSnackBarSuccess('Dado Pessoal excluído com sucesso !');
    }, err => {
      console.error(err);
    });
  }

  buscarTiposDados() {
    this.dadosPessoaisService.getTiposDados().subscribe(data => {
      this.tiposDados = data;
      console.log(this.tiposDados);
    }, err => {
      console.error(err);
    }, () => {
      this.loading1TipoDado = true;
    });
  }

  buscarTodosOsDadosPessoais() {
    this.dadosPessoaisService.getDadosPessoais().subscribe(data => {
      console.log(data);
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, err => {
      console.error(err);
    });
  }

  buscarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(data => {
      this.clientes = data.content;
    }, err => {
      console.error(err);
    }, () => {
      this.loading = false;
    });
  }

  onChangeEmpresa(event) {
    this.tipos = [];
    this.loading = true;
    this.clienteId = event;
    this.listarAreas(this.clienteId);
  }

  listarAreas(clienteId) {
    this.areaService.getDescricaoAreasCliente(clienteId).subscribe(data => {
      this.areas = data;
    }, err => {
      console.error(err);
    }, () => {
      this.loading = false;
    });
  }

  onChangeArea(event) {
    console.log(event.id);
    this.loading = true;
    this.areaId = event;
    this.getNodeClienteArea(this.clienteId, this.areaId);
  }

  getNodeClienteArea(clienteId, areaId) {
    this.service.getNodeClienteArea(clienteId, areaId).subscribe(data => {
      if (data.length === 0) {
        this.openSnackBarError('Nenhum Tipo Documental associado !');
        this.loading = false;
      } else {
        this.loading = false;
        this.tipos = data;
      }
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/usuario/dados-pessoais/dados-pessoais.component.ts